export default {
    data() {
        return {
            dyABVariations: dynamicYieldABVariations
        }
    },
    
    methods: {
        getChoiceBySelector(selector) {
            if (this.dyABVariations != null && this.dyABVariations.choices != null) {
                return this.dyABVariations.choices?.find(choice => choice?.name?.toUpperCase() === selector.toUpperCase());
            }
            
            return null;
        },

        getVariationBySelectorAndType(selector, type) {
            const choice = this.getChoiceBySelector(selector);
            if (choice != null) {
                return choice.variations?.find(variation => variation?.type?.toUpperCase() === type)?.data;
            }

            return null;
        },
        
        getCustomJSONVariationBySelector(selector) {
            return this.getVariationBySelectorAndType(selector, "CUSTOM_JSON");
        }
    }
}